// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CreditCardMinusSvg from '@rsuite/icon-font/lib/application/CreditCardMinus';
var CreditCardMinus = createSvgIcon({
  as: CreditCardMinusSvg,
  ariaLabel: 'credit card minus',
  category: 'application',
  displayName: 'CreditCardMinus'
});
export default CreditCardMinus;